import { apiGet, apiPost } from './client';
import {
  ReimbursementResponse,
  SetupIntentResponse,
  FileUploadResponse,
  PersonCareData,
  CaregiverCareData,
  TermsAndConditionsData,
  Question,
} from '../types';

// Quiz state types for API
interface QuizTemplateParams {
  quizPersonInNeedOfCare: {
    quizPerson: Question[];
    indexPerson: number;
  };
  quizCaregiverPerson: {
    quizCaregiver: Question[];
    indexCaregiver: number;
  };
  quizRegisteredCaregiver: {
    quizRegistered: Question[];
    indexRegistered: number;
  };
}

interface UpsertReimbursementBody {
  email: string;
  option: number;
  ref: string;
  ccForm: boolean;
  params: {
    personCare: PersonCareData;
    caregiverCare: CaregiverCareData;
    termAndConditions: TermsAndConditionsData;
  };
  templateParams: QuizTemplateParams;
}

// Start the Sorgenloskarte flow
export const startSorgenloskarte = (body: {
  email: string;
  option: number;
}): Promise<SetupIntentResponse> => {
  return apiPost<SetupIntentResponse>(
    'api/v1/payments/reimbursement/cc-pre-payment/setup-intent',
    body
  );
};

// Get reimbursement data by ref
export const getReimbursements = (ref: string): Promise<ReimbursementResponse> => {
  return apiGet<ReimbursementResponse>(`api/v1/reimbursements/${ref}`);
};

// Create/Update reimbursement form (upsert)
export const upsertReimbursement = (body: UpsertReimbursementBody): Promise<{ ref: string }> => {
  return apiPost<{ ref: string }>('api/v1/reimbursements', body);
};

// Submit reimbursement
export const submitReimbursement = (body: {
  ref: string;
  email: string;
  option: number;
}): Promise<void> => {
  return apiPost<void>('api/v1/reimbursements/submit', body);
};

// Upload file
export const uploadFile = (
  formData: FormData,
  ref: string,
  type: string
): Promise<FileUploadResponse> => {
  // Don't set Content-Type - axios will set it with proper boundary for FormData
  return apiPost<FileUploadResponse>(
    `api/v1/reimbursements/${ref}/documents?type=${type}`,
    formData
  );
};

// Upload base64 file (for signature)
export const uploadBase64File = (
  body: { data: string; documentType: string },
  ref: string
): Promise<FileUploadResponse> => {
  return apiPost<FileUploadResponse>(`api/v1/reimbursements/${ref}/documents/base-64`, body);
};

// Get PDF / Resend email
export const getPdf = (body: { ref: string }): Promise<void> => {
  return apiPost<void>('api/v1/reimbursements/resend-email', body);
};

// File upload types mapping
export const FILE_UPLOAD_TYPES = {
  attachmentForInsuranceCard: 'RC_INSURANCE_CARD_OR_STATUS',
  attachmentForPflegegradPaper: 'RC_CARE_DEGREE_CERTIFICATE',
  certificate: 'RC_COPY_OF_THE_CARE_CERTIFICATE',
  document: 'RC_CAREGIVER_COPY_OF_THE_CARE_CERTIFICATE',
  signature: 'RC_SIGNATURE',
} as const;
